import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Fragment, useState } from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  Create,
  FormDataConsumer,
  ImageField,
  ImageInput,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRecordContext,
  useTranslate
} from 'react-admin';
import dayjs from 'dayjs';
import { getChainId } from '../lib';
import { filterToQuery } from '../utils';

const AddCoupon = ({ onClose }) => {
  const notify = useNotify();
  const translate = useTranslate();
  const record = useRecordContext();
  const [displayModal, setDisplayModal] = useState(true);

  const onSuccess = () => {
    notify('ra.notification.created');
    setDisplayModal(false);
    onClose();
  };

  return (
    <Fragment>
      <Dialog
        open={displayModal}
        onClose={() => { setDisplayModal(false); onClose(); }}
        aria-label="Adicionar cupom para um cliente"
      >
        <DialogTitle>{'Adicionar cupom para o cliente'}</DialogTitle>
        <DialogContent>
          <Create
            resource={`customers/${record.id}/coupons`}
            mutationOptions={{ onSuccess }}
            transform={(data) => {
              const { daysToExpire, ...rest } = data;
              return {
                ...rest,
                expiresAt: daysToExpire
                  ? dayjs().add(daysToExpire, 'days').toISOString()
                  : undefined
              };
            }}
          >
            <SimpleForm>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <TextInput
                  label="Nome"
                  source="title"
                />
                <TextInput
                  label="Descrição"
                  source="description"
                />
                <ReferenceInput
                  source="placeId"
                  filter={{ chainId: getChainId() }}
                  reference="places"
                  sort={{ field: 'name', order: 'ASC' }}
                  perPage={9999}
                  allowEmpty
                >
                  {/* validate no ReferenceInput é ignorado no react-admin 5; vale no filho. */}
                  <AutocompleteInput
                    label="Posto"
                    validate={required()}
                    optionText="name"
                    filterToQuery={filterToQuery}
                    noOptionsText={translate('ra.input.autocomplete.no_options_text')}
                  />
                </ReferenceInput>
                <NumberInput
                  label="Dias até expiração"
                  source="daysToExpire"
                  min={1}
                />
                <FormDataConsumer>
                  {({ formData }) => formData.daysToExpire ? (
                    <div style={{ marginTop: -10, marginBottom: 10, fontSize: '0.875rem', color: '#666' }}>
                      Expira em: {dayjs().add(formData.daysToExpire, 'days').format('DD/MM/YYYY HH:mm')}
                    </div>
                  ) : null}
                </FormDataConsumer>
                <BooleanInput
                  label="Resgatar em qualquer local"
                  source="redeemAnywhere"
                />
                <ImageInput source="imagefile" label="Imagem" accept={{ 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] }}>
                  <ImageField source="src" label="Imagem" />
                </ImageInput>
              </div>
            </SimpleForm>
          </Create>
        </DialogContent>
      </Dialog>
    </Fragment >
  )
}

export default AddCoupon;
